import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OutlinedSelectOption } from '../../base/fc-outlined-select/fc-outlined-select.component';

@Component({
  selector: 'fc-filter-type-outlined-select',
  templateUrl: './fc-filter-type-outlined-select.component.html',
  styleUrls: ['./fc-filter-type-outlined-select.component.scss']
})
export class FcFilterTypeOutlinedSelectComponent {
  @Input()
  public label: string;

  @Input()
  public required: boolean;

  @Input()
  public control: FormControl;

  @Input()
  options: OutlinedSelectOption[];
}
